import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=54364dc3&"
import script from "./Opportunity.vue?vue&type=script&lang=js&"
export * from "./Opportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54364dc3')) {
      api.createRecord('54364dc3', component.options)
    } else {
      api.reload('54364dc3', component.options)
    }
    module.hot.accept("./Opportunity.vue?vue&type=template&id=54364dc3&", function () {
      api.rerender('54364dc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/leads/Edit/Opportunity.vue"
export default component.exports